import React from 'react';
import { useTranslation } from 'react-i18next';
import { checkArray } from '../helper';
import Loader from '../Utility/Loader/Loader';
import OutsideAlerterwithClassName from '../Utility/OutsideAlerter/OutsideAlerterwithClassName';

function SeasonFilter({
  loader,
  handleSelectAll,
  handleInputChange,
  onAddProduct,
  handleProductSelect,
  selectedProducts,
  handleClose,
  allProducts,
  disabledBtn,
  state,
  isShowFilter,
  showFilters,
  filterOpenBy,
  handleInputFocus,
  isSeasonFocused,
  handleOutSideClickToSideBar,
}) {
  const btnDefaultActiveClass = 'btn btn-default active';
  const btnDefaultClass = 'btn add-product-icon';
  const { t } = useTranslation('common');

  const getPLaceholderName = () => {
    if (selectedProducts?.length !== 0 && selectedProducts?.length === allProducts?.length) {
      return t('SEASON_FILTER.ALL_ITEMS_SELECTED');
    }
    return t('SEASON_FILTER.SEARCH_PRODUCTS');
  };

  return filterOpenBy === 'PIM' ? (
    <>
      <div className="filter-select-product">
        <input type="text" placeholder={getPLaceholderName()} onChange={handleInputChange} className="product-search-input" onFocus={handleInputFocus} />
      </div>
      <OutsideAlerterwithClassName handleOutSideClick={handleOutSideClickToSideBar} classItem="icon-filter">
        <div className="filter-dropdown">
          {isSeasonFocused && (
            <div className="btn-container">
              <button
                type="button"
                onClick={() => onAddProduct(selectedProducts)}
                className={selectedProducts.length === 0 ? btnDefaultActiveClass : btnDefaultClass}
                disabled={disabledBtn || selectedProducts.length === 0}
              >
                {t('SEASON_FILTER.ADD')}
              </button>
              {isShowFilter ? showFilters() : null}
            </div>
          )}
          {loader ? (
            <Loader />
          ) : (
            isSeasonFocused && (
              <ul className="product-list-ul">
                {checkArray(allProducts) ? (
                  allProducts.map((product, i) => (
                    <li key={product}>
                      <input
                        id={`product_${i}`}
                        type="checkbox"
                        checked={selectedProducts.includes(product._id)}
                        onChange={(event) => handleProductSelect(event, product._id)}
                        className="product-item"
                      />
                      <label htmlFor={`product_${i}`}>
                        {product?.number}
                        {'  '}|{'  '}
                        {product?.description}
                      </label>
                    </li>
                  ))
                ) : (
                  <p className="p-3 f-16 text-medium m-0 text-center">{t('SEASON_FILTER.NO_PRODUCTS_FOUND')}</p>
                )}
              </ul>
            )
          )}
        </div>
      </OutsideAlerterwithClassName>
    </>
  ) : (
    <>
      <div className="filter-select-product">
        <input
          type="text"
          placeholder={t('SEASON_FILTER.SEARCH_PRODUCTS')}
          onChange={handleInputChange}
          className="product-filter-input"
          onFocus={handleInputFocus}
        />
        {isShowFilter ? showFilters() : null}
      </div>
      <div>
        {loader ? (
          <Loader />
        ) : (
          <ul className="product-list-ul new-bomscroll">
            <li>
              {' '}
              <div className="common-checkbox">
                <input id="select_all" type="checkbox" checked={state.selectedAll} onChange={handleSelectAll} className="product-add-item" />
                <label htmlFor="select_all" className="chklabel product-chklabel">
                  <span>{t('SEASON_FILTER.SELECT_ALL')}</span>
                </label>
              </div>
            </li>
            {isSeasonFocused &&
              (checkArray(allProducts) ? (
                allProducts.map((product, i) => (
                  <li key={product}>
                    <div className="common-checkbox">
                      <input
                        id={`product_${i}`}
                        type="checkbox"
                        checked={selectedProducts.includes(product._id)}
                        onChange={(event) => handleProductSelect(event, product._id)}
                        className="product-add-item"
                      />
                      <label htmlFor={`product_${i}`} className="chklabel product-chklabel">
                        <span>
                          {product?.number}
                          {'  '}|{'  '}
                          {product?.description}
                        </span>
                      </label>
                    </div>
                  </li>
                ))
              ) : (
                <p className="p-3 m-0 text-center">{t('SEASON_FILTER.NO_PRODUCTS_FOUND')}</p>
              ))}
          </ul>
        )}
      </div>
    </>
  );
}

export default SeasonFilter;
